import { Component, OnInit, Input } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { StoreSearchService } from '../store-search.service';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { StoreSearchDTO } from '../../../../../shared/store-search-dto';
import { TrackingService } from '../../tracking.service';

@Component({
  selector: 'pv-store-search',
  templateUrl: './store-search.component.html',
  styleUrls: ['./store-search.component.scss']
})
export class StoreSearchComponent implements OnInit {
  @Input() isWholesale: boolean;
  items: StoreSearchDTO[]
  selectedValue: any = {};
  loading = false;
  input$ = new Subject<string>();
  item: StoreSearchDTO;

  totalCount = 0;
  term = '';

  DEBOUNCE_TIME = 650;

  constructor(
    private storeSearchService: StoreSearchService,
    private router: Router,
    private route: ActivatedRoute,
    private trackingService: TrackingService
  ) { }

  ngOnInit() {
    this.input$.pipe(
      distinctUntilChanged(),
      debounceTime(this.DEBOUNCE_TIME)
    ).subscribe(term => {
      this.term = term;
      this.loadItems()
    })
  }

  private loadItems(append: boolean = false) {
    this.loading = true;
    this.storeSearchService.getItems(this.term)
    .subscribe(searchDTO => {
      this.items = searchDTO;
      this.item = null;
      this.loading = false;

      // Google Analytics
      this.trackingService.event('search', 1, { search_term: this.term }); // WE NEED ACCOUNT HERE #1200
    })
  }

  onChange(item: StoreSearchDTO) {
    this.item = item;
    if (!item) {
      return;
    }
    if (this.isWholesale) {
      if (!this.item.type) {
        this.router.navigate(['/wholesale', item.router[1]])
      } else {
        const queryParams: Params = { product: item.id }
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams,
          queryParamsHandling: 'merge'
        })
      }
    } else {
      this.router.navigate(item.router)
    }
  }

  onEnter(event: KeyboardEvent) {
    event.stopPropagation()
    timer(this.DEBOUNCE_TIME)
    .subscribe(x => {
      if (!this.item) {
        // Wait for debounce after they press enter
        const queryParams: Params = { q: this.term }
        this.router.navigate(['/search'], { queryParams })
      }
    })
  }
}
